<template>
  <div>
    <b-card no-body class="p-0" v-if="liberaInvestimentos">
      <b-tabs card class="p-0 investimentos" justified>
        <b-tab
          :title="tab.titulo"
          v-for="tab in investimentos.rubricas"
          :key="tab.titulo"
          class="p-0"
        >
          <div>
            <h6 v-if="!investimentos[tab.investimento]" class="p-3">Sem dados!</h6>
            <investimento-table
              :endpoint="endpoint"
              :rubrica="tab.rubrica"
              v-if="investimentos[tab.investimento]"
              :investimentos="investimentos[tab.investimento]"
              :ref="tab.investimento"
            />
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
import PropostaService from "@/common/services/proposta/proposta.service";
//import helpers from "@/common/utils/helpers";
import investimentoTable from "./components/investimentoTable";
import cloneDeep from "lodash/cloneDeep";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";

export default {
  mixins: [AlertasMixin],
  components: {
    investimentoTable,
  },
  props: {
    propostaId: {
      type: String,
      required: true,
    },
    propostaOriginalId: {
      type: String,
      required: true,
    },
    endpoint: {
      type: String,
      required: true,
    },
    aprovada: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    investimentos: {
      rubricas: [],
    },
    salvos: 0,
  }),
  methods: {
    buscarInvestimentos: function () {
      let rubricas = [
        {
          titulo: "RH - Recursos humanos",
          rubrica: "recurso-humano",
          investimento: "recursoHumano",
          ordem: 1,
        },
        {
          titulo: "ST - Serviços de terceiros",
          rubrica: "servico-terceiro",
          investimento: "servicoTerceiro",
          ordem: 2,
        },
        {
          titulo: "MC - Materiais de consumo",
          rubrica: "material-consumo",
          investimento: "materialConsumo",
          ordem: 3,
        },
        {
          titulo: "MPE - Materiais permanentes e equipamentos",
          rubrica: "material-permanente-equipamento",
          investimento: "materialPermanente",
          ordem: 4,
        },
        {
          titulo: "VD - Viagens e diárias",
          rubrica: "viagem-diaria",
          investimento: "viagemDiarias",
          ordem: 5,
        },
        {
          titulo: "OU - Outros",
          rubrica: "outro-recurso",
          investimento: "outrosRecursos",
          ordem: 6,
        },
      ];

      this.investimentos = {
        rubricas: [],
      };

      rubricas.forEach((rubrica) => {
        this.buscarInvestimento(rubrica);
      });
    },
    buscarInvestimento(rubrica) {
      PropostaService.buscarInvestimentoExecutora(this.propostaId, rubrica.rubrica).then(
        (response) => {
          let investimento = cloneDeep(this.investimentos);
          if (!investimento.rubricas.find((el) => el.rubrica == rubrica.rubrica))
            investimento.rubricas.push(rubrica);
          investimento[rubrica.investimento] = response.data.data;

          if (investimento.rubricas.length == 6) {
            investimento.rubricas.sort((a, b) => {
              return a.ordem - b.ordem;
            });
          }

          this.investimentos = investimento;
        }
      );
    },
    montar() {
      PropostaService.setEndpoint(this.endpoint);
      this.buscarInvestimentos();
    },
  },
  mounted() {},
  computed: {
    permissao() {
      return this.$store.getters["app/retornaPermissao"]("PropostaInvestimento");
    },
    liberaInvestimentos: function () {
      return this.investimentos.rubricas.length == 6;
    },
  },
};
</script>
<style>
.investimentos .card-header {
  background: #f3f2f2;
  border-bottom: 1px solid #e5e5e5;
}

.investimentos .card-header-tabs {
  align-items: end;
}
</style>
